module.exports = __webpack_public_path__ + "media/components/assets/img/bg/airport-lp-flyo-139515e1cf2a8c3454d9d3b2b59f6a43.svg";